import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { DataUploadService } from '../../../core/services/data-upload.service';

interface WorkflowStep {
  path: string;
  label: string;
  icon: string;
  /** Steps not yet implemented are shown but disabled. */
  enabled: boolean;
}

@Component({
  selector: 'app-step-nav',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, MatIconModule],
  templateUrl: './step-nav.component.html',
  styleUrl: './step-nav.component.scss',
})
export class StepNavComponent {
  private readonly upload = inject(DataUploadService);

  protected readonly steps: WorkflowStep[] = [
    { path: '/upload', label: 'Upload Data', icon: 'cloud_upload', enabled: true },
    { path: '/discovery', label: 'Data Discovery', icon: 'search', enabled: true },
    { path: '/interval', label: 'Interval Builder', icon: 'straighten', enabled: true },
    { path: '/clustering', label: 'Clustering', icon: 'scatter_plot', enabled: true },
    { path: '/normalization', label: 'Normalization', icon: 'tune', enabled: true },
    { path: '/export', label: 'Download Results', icon: 'download', enabled: true },
  ];

  /**
   * A step is locked until both files are chosen. The Upload step is always
   * reachable so the user can pick files.
   */
  protected isLocked(step: WorkflowStep): boolean {
    return step.path !== '/upload' && !this.upload.ready();
  }
}
